import * as React from "react";
const SvgFiRrRugby = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-rugby_svg__a)">
      <path
        fill="#062147"
        d="M22.1 1.9C18.664-1.53 9.372-.067 4.652 4.652-.068 9.372-1.53 18.664 1.9 22.1a8.1 8.1 0 0 0 5.767 1.88 17.43 17.43 0 0 0 11.681-4.632C24.066 14.63 25.531 5.336 22.1 1.9m-5.767.1a6.23 6.23 0 0 1 4.351 1.314C21.7 4.331 22.111 6.3 21.96 8.545l-6.5-6.5c.295-.019.591-.045.874-.045M3.316 20.684C2.3 19.67 1.89 17.7 2.041 15.455l6.5 6.5c-2.24.155-4.21-.255-5.225-1.27m14.618-2.75a14.7 14.7 0 0 1-6.929 3.657l-8.6-8.6a14.7 14.7 0 0 1 3.661-6.925 14.65 14.65 0 0 1 6.94-3.646l8.586 8.586a14.67 14.67 0 0 1-3.658 6.928m-.227-6.227a1 1 0 0 1-1.414 0L15 10.414 13.414 12l1.293 1.293a1 1 0 1 1-1.414 1.414L12 13.414 10.414 15l1.293 1.293a1 1 0 1 1-1.414 1.414l-4-4a1 1 0 0 1 1.414-1.414L9 13.586 10.586 12l-1.293-1.293a1 1 0 0 1 1.414-1.414L12 10.586 13.586 9l-1.293-1.293a1 1 0 0 1 1.414-1.414l4 4a1 1 0 0 1 0 1.414"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-rugby_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrRugby;
